import React from 'react'
import QuizzLayout from './QuizLayout';
import {ReactComponent as NoQuiz} from '../../../assets/img/No_Quiz.svg'
import CustomLink from '../shared/CustomLink';
import EmptyStateLayout from '../shared/EmptyStateLayout';
import CustomDataTable from '../shared/CustomDataTable';
import {withClientContainer} from '../../containers/gamification'
import { formatNumber } from '../normalizer';
import { t } from '../../../i18n'
import CustomButton from '../shared/CustomButton';

const QuizHistory = props => {
  const { quizzes } = props
  const { currency_label: currencyLabel } = props.client

  const noElements = quizzes.length === 0

  // Column definitions
  const columns = [
    {
      key: 'quiz_name',
      label: "Questionário",
      sortKey: 'quiz_name',
    },
    {
      key: 'total_answers',
      label: "Nº Perguntas",
      sortKey: 'total_answers',
    },
    {
      key: 'total_corrects',
      label: "Perguntas certas",
      sortKey: 'total_corrects',
    },
    {
      key: 'total_points',
      label: currencyLabel + ' ganhos',
      sortKey: 'total_points',
      align: 'right',
    },
    {
      key: 'review',
      label: "",
      sortable: false,
      align: 'center',
    },
  ];

  // Sort function
  const sortFn = (data, sort) => {
    return [...data].sort((a, b) => {
      const multiplier = sort.direction === 'asc' ? 1 : -1;
      if (sort.key === 'quiz_name') {
        const nameA = (a.quiz_name || '').toLowerCase();
        const nameB = (b.quiz_name || '').toLowerCase();
        return nameA.localeCompare(nameB) * multiplier;
      }
      if (sort.key === 'total_answers') {
        return (parseInt(a.total_answers) - parseInt(b.total_answers)) * multiplier;
      }
      if (sort.key === 'total_corrects') {
        return (parseInt(a.total_corrects) - parseInt(b.total_corrects)) * multiplier;
      }
      if (sort.key === 'total_points') {
        return (parseFloat(a.total_points) - parseFloat(b.total_points)) * multiplier;
      }
      return 0;
    });
  };

  // Custom row renderer
  const renderRow = (item, index, className) => {
    return (
      <tr key={item.id || index} className={`data-table__row ${className}__row`}>
        <td className={`data-table__cell ${className}__cell ${className}__cell--quiz_name`}>
          {item.quiz_name}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--total_answers`}>
          {item.total_answers}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--total_corrects`}>
          {item.total_corrects}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--total_points`}>
          {formatNumber(item.total_points)}
        </td>
        <td className={`data-table__cell ${className}__cell ${className}__cell--review`}>
          <div className="flex justify-end">
            <CustomButton link tight
              className={`${className}__review-link`}
              to={"/quiz/history/" + item.id}
            >
              Rever
            </CustomButton>
          </div>
          
        </td>
      </tr>
    );
  };

  return (
    <QuizzLayout>
      {noElements ? (
        <EmptyStateLayout message={t('gamification2026.quiz.empty-history')}>
          <NoQuiz className="flex-1 mb-5"></NoQuiz>
        </EmptyStateLayout>
      ) : (
        <div className="quiz-history-container">
          <CustomDataTable
            className="quiz-history-table"
            columns={columns}
            data={quizzes}
            renderRow={renderRow}
            rowKey={(item, index) => item.id || index}
            sortFn={sortFn}
            emptyMessage={t('gamification2026.quiz.empty-history')}
          />
        </div>
      )}
    </QuizzLayout>
  )
}
export default withClientContainer(QuizHistory)
